<wsb-modal
  class="custom-modal-width"
  cancelButtonEnable="true"
  (close)="activeModal.close()"
  (dismiss)="fileModalDismiss()"
  title="{{ 'send_sms_recipients_file_modal_title' | translate }}"
  primaryButtonText="common_ok"
  (primary)="activeModal.close()"
>
  <div body>
    <span>{{ 'send_sms_recipients_file_modal_description' | translate }}</span>
    <div class="">
      <table class="table">
        <thead>
          <tr>
            <th scope="col" translate>file_fields_matching_dynamic_fields</th>
            <th scope="col" translate>file_fields_matching_file_columns</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let field of columnToContactFields">
            <td>{{ field.idField | translate }}</td>
            <td>
              <ng-select
                placeholder="{{ field.label }}"
                #dynamicsFieldsSelection
                [items]="fieldsMapping"
                [searchable]="false"
                bindLabel="label"
                bindValue="id"
                (change)="buildColumnToContactFields(field, $event)"
                class="margin-button"
                [clearable]="false"
              >
              </ng-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</wsb-modal>
